import Alpine from "alpinejs";
import { getCookie, setCookie } from "../modules/helpers/cookie";

Alpine.magic("getCookie", () => (name) => {
    return getCookie(name);
});

Alpine.magic("setCookie", () => (name, value, options = {}) => {
    setCookie(name, value, options);
});